// 連撃3段目 (重い締め) の強さの比較版 (2026-10-09 ユーザー「プレイヤーの攻撃3段の攻撃力は差をつけてるか確認して。
//   最後の1撃を大きく削るなど設定できている？ 1：1：1.5 くらいのダメージと体幹効率が良い」)。
//   調べた今の値・比較の表 = docs/research/2026-10-09-economy-table.md。
//
// 今 (配布版) の3段は、体力ダメージも体幹ダメージも全段同じ (重さは踏み込み・命中の止まり・揺れ・音と、振り終わりの隙で出している)。
//   この比較版は 3段目の命中だけ、体力ダメージと体幹ダメージ (どちらも) に同じ倍率を掛ける。1段目・2段目・見切り反撃・致命は変えない。
//   倍率 = 百分率。100 = 今のまま (配布版の既定)・150 = 1:1:1.5。DEV の ?combo3rd=150 だけが変える (main.ts の DEV の URL ブロック)。
//   ⚠️ 3段目は振り終わりまで 1000ms (1・2段目は 420ms)。時間あたりの効率は 150 でも 1・2段目の約 63% (表は研究文書)。

let percent = 100

/** 3段目の命中に掛ける倍率 (1 = 今のまま)。 */
export function combo3rdMul(): number {
  return percent / 100
}

/** 百分率 (50〜400) を受ける。数でない・範囲外は無視 (今の値のまま)。null / undefined は何もしない。 */
export function setCombo3rdPercent(value: string | number | null | undefined): void {
  if (value === null || value === undefined || value === '') return
  const n = Number(value)
  if (!Number.isFinite(n) || n < 50 || n > 400) return
  percent = n
}

export function combo3rdPercent(): number {
  return percent
}

// ===== 3段目の得「体幹の戻りを止める」(2026-10-12 配布版の既定へ・ユーザーの答え D-1「1.8秒」) =====
//   元の比較 = docs/research/2026-10-12-combo3-benefit-options.md、作った物 = docs/research/2026-10-12-combo3-lock-bar-status.md、
//   配布版に入れた記録 = docs/research/2026-10-12-combo3-ship-and-tut-assist.md。
//
// 3段目の通常命中 (上の倍率と同じ条件 = 見切り反撃・受けは対象外) で、ボスの体幹の戻りの猶予
//   (boss.postureRegenLockSec・普段は econ の bossPostureGraceSec = 騎士 0.25 秒など) をその一撃だけ長くする。量は今のまま (100%)。
//   その一撃で崩れた時 (体幹満タン・体力が床) は長くしない (崩れ中は戻らないので意味が無く、致命の後へ持ち越すため)。
//   止まっている間は HUD の体幹の帯の縁が金にほのかに光り、残り時間で細る (render.ts drawBossPostureGauge)。
//   配布版の既定 = 入 (1.8 秒)。旧 (3段目の得なし・稽古も旧の並び) は DEV ?combo3rd=off だけが戻す (main.ts の DEV の箱)。
//   止める秒は DEV &combo3rdLockMs=<300〜10000> で替えられる (比較用)。
export const COMBO3_LOCK_DEFAULT_MS = 1800
let lockOn = true
let lockMs = COMBO3_LOCK_DEFAULT_MS

export function setCombo3rdLock(on: boolean): void {
  lockOn = on
}

/** 止める長さ (ms・300〜10000)。数でない・範囲外は無視。null / '' は何もしない。 */
export function setCombo3rdLockMs(value: string | number | null | undefined): void {
  if (value === null || value === undefined || value === '') return
  const n = Number(value)
  if (!Number.isFinite(n) || n < 300 || n > 10000) return
  lockMs = n
}

/** 3段目の命中で止める秒 (0 = 切 = 旧 = DEV ?combo3rd=off の時だけ)。 */
export function combo3rdLockSec(): number {
  return lockOn ? lockMs / 1000 : 0
}

// 案2 遅れて減る帯 (開発版のまま = DEV &combo3rdBar=1 の時だけ・10-12 の答え D-2「気づかなかった」で配布版へは入れない)。
//   3段目で削った分だけ、ボスの体力の帯に白い残りが一拍残ってから縮む (ダークソウルの帯の残りと同じ形)。
//   体幹の帯は溜まる帯なので、溜まった分を白く光らせ、一拍の後に金へ戻す
//   (伸びそのものを遅らせると、次のパリィで崩れるかの読みが狂うため、伸びは今どおりすぐ)。
//   1・2段目は今のまま一度に縮む = 3段目だけ違いが見える。
export const HEAVY_BAR_GHOST = { holdSec: 0.5, drainSec: 0.3 } as const
let barOn = false

export function setCombo3rdBar(on: boolean): void {
  barOn = on
}

export function combo3rdBarOn(): boolean {
  return barOn
}

// 体幹の戻りが止まっている間の帯の見せ方 (2026-10-28 作者「体幹ゲージが止まっていることをわかりやすく見せて。色が近すぎるのとうまく囲えていないのが原因」)。
//   'frost' = 配布版: 溜まった所を冷たい銀の霜で覆い、先端に留め金を立てる (金の帯と色を分ける・src/boss_hud_view.ts)。
//   'gold'  = 前の形 (10-12〜10-28 の配布版・縁を金でほのかに光らせるだけ)。DEV ?postureHoldLook=gold だけが戻す (稽古の止め方も前の形へ = src/tut_focus.ts)。
export type PostureHoldLook = 'frost' | 'gold'
let holdLook: PostureHoldLook = 'frost'
export function setPostureHoldLook(v: string | null | undefined): PostureHoldLook {
  holdLook = v === 'gold' ? 'gold' : 'frost'
  return holdLook
}
export function postureHoldLook(): PostureHoldLook {
  return holdLook
}

// 霜の帯の先端の印 (2026-10-31 作者「体幹が止まった時にゲージの先に白い線と矢印が突くようになったのダサいからデザインを改めてほしい」)。
//   'none'    = 配布版 (10-31 作者が答えるページで D を選んだ): 印なし。霜の覆いだけ。
//   'clasp'   = 留め金: 溝より上下にはみ出す白い縦の棒と上下の楔 (10-28)。
//   'glow'    = 灯の滲み: 先端に青白い灯がにじみ、ゆっくり息をする (棒も楔も無い柔らかい光)。
//   'crystal' = 霜の結晶: 先端から空の溝へ細い霜の針が伸び、小さな粒が瞬く (溝の高さの中に収まる)。
//   'flame'   = 灯の揺れ: 先端に小さな青い灯火が立ち、揺れる。
//   DEV ?postureHoldTip= で切り替える (src/boss_hud_view.ts drawPostureFrost)。
export type PostureHoldTip = 'clasp' | 'glow' | 'crystal' | 'flame' | 'none'
const HOLD_TIPS: readonly string[] = ['clasp', 'glow', 'crystal', 'flame', 'none']
let holdTip: PostureHoldTip = 'none'
export function setPostureHoldTip(v: string | null | undefined): PostureHoldTip {
  holdTip = HOLD_TIPS.includes(v ?? '') ? (v as PostureHoldTip) : 'none'
  return holdTip
}
export function postureHoldTip(): PostureHoldTip {
  return holdTip
}

/** URL の ?combo3rd= を読み分ける。'off' = 旧 (3段目の得なし)、'lock' = 既定どおり (入)、数 = 倍率 (止めるかは変えない)。 */
export function setCombo3rdMode(value: string | null | undefined): void {
  if (value === 'off') {
    setCombo3rdLock(false)
    return
  }
  if (value === 'lock') {
    setCombo3rdLock(true)
    return
  }
  setCombo3rdPercent(value)
}

/** いま効いている比較版 (DEV の window.__combo3rdTrial が返す)。 */
export function combo3rdTrialInfo(): { percent: number; lockMs: number; bar: boolean } {
  return { percent, lockMs: lockOn ? lockMs : 0, bar: barOn }
}

/** テスト用: 全部配布版の既定 (倍率 100%・止める 1.8 秒・白い残りなし) へ戻す。 */
export function resetCombo3rdTrials(): void {
  percent = 100
  lockOn = true
  lockMs = COMBO3_LOCK_DEFAULT_MS
  barOn = false
}
